<template>
  <div>
    <login-header>
      <template slot="subtitle">Use your SSO provider to access Celtra.</template>
    </login-header>
    <div class="inputs-container">
      <div class="login-button-container">
        <dialog-button size="small" class="login-dialog-button" :href="ssoLoginUrl">Sign in with {{ domainConstraint.label }}</dialog-button>
      </div>
    </div>
  </div>
</template>

<script>
import DialogButton from 'design-system/components/Buttons/Button/DialogButton.vue'
import LoginHeader from '@/components/LoginHeader.vue'
import { mapGetters, mapState } from 'vuex'

export default {
  name: 'LoginWithSsoStep',
  components: {
    LoginHeader,
    DialogButton
  },
  computed: {
    ...mapState('login', ['email', 'domainConstraint']),
    ...mapGetters('login', ['ssoLoginUrl'])
  }
}
</script>

<style lang="less">
@import '~@/shared/styles.less';
</style>

<style scoped lang="less">
@import (reference) '~@/design-system/src/less/variables.less';

.login-button-container {
  padding: 44px 0;
}
</style>
